
"use strict";

// Generated from the active Shopify locale.

var xxzpawvbpvwnwawbnazvkkpqvbhwadva =
{
	language: "Ü",
	regions: ["*"],
	strings:
	{
		language: "Deutsch"
		, comma: ","
		, thousands_seperator: "." 
		, decimal: ","
		, select: "Auswählen"
		, unselect: "Abwählen"
		, calculate: "Ergebnis berechnen"
		, units:
		{
            default: "m",
			metric: "metrisch",
			imperial: "imperial",
			short:
			{
				"l": "L"
				,"ml": "ml"
				,"m": "m"
				,"cm": "cm"
				,"mm": "mm"
				,"f": "f"
				,"in": "in"
				,"sqare_m": "m²"
				,"sqare_cm": "cm²"
				,"sqare_f": "f²"
				,"sqare_in": "in²"
			},
			long:
			{
				"l": "Liter"
				,"ml": "Milliliter"
				,"m": "Meter"
				,"cm": "Zentimeter"
				,"mm": "Millimeter"
				,"f": "Fuß"
				,"in": "Zoll"
				,"sqare_m": "Quadratmeter"
				,"sqare_cm": "Quadratzentimeter"
				,"sqare_f": "Quadrat-Fuss"
				,"sqare_in": "Quadrat-Zoll"
			}
		}
		, steps:
		{
			"remove" : 
			{
				"label": "Entfernen"
				,"intro": ""
				,"extro": ""
			}
			,"wash" : 
			{
				"label": "Waschen"
				,"intro": ""
				,"extro": ""
			}
			,"grind" : 
			{
				"label": "Abschleifen"
				,"intro": ""
				,"extro": ""
			}
			,"prime" :
			{
				"label": "Grundieren"
				,"intro": ""
				,"extro": ""
			}
			,"apply" : 
			{
				"label": "Auftragen"
				,"intro": ""
				,"extro": ""
			}
		}
		, instructions: {}
		, product_kinds:
		{
			by_ID:
			{ "Antifouling"     : "Antifouling"
			, "Primer"          : "Primer"
			, "Old_Antifouling" : "Altes Antifouling"
			}
		}
		, product_categories:
		{
			by_ID:
			{ "Standard"           : "Standard"
			, "Premium"            : "Premium"
			, "No_Biocide"         : "Biozidfrei"
			, "No_Biocide_Premium" : "Biozidfrei Premium"
			}
		}
		, products:
		{
			localized_name_by_ID: {}
		}
		, questions:
		{
			go_to_previous: "Zur vorherigen Frage",
			go_to_next: "Zur nächsten Frage",
            need_to_asnwer_all: "Bitte beantworten Sie zuerst alle Pflichtfragen.",
			invalid_measurements: "Bitte geben Sie für Länge, Breite und Tiefgang gültige Maße größer als 0 ein.",
			q1: 
			{
				label: "Wie ist der Zustand Ihres aktuellen Antifoulings?"
				, text: "Der Zustand entscheidet, ob die vorhandene Beschichtung überarbeitet werden kann oder vollständig entfernt werden muss."
				, number:"1"
			},
			q2:
			{
				label: "Was ist das Rumpfmaterial Ihres Bootes?"
				, text: "Das Material des Rumpfs entscheidet, welches Antifouling verwendet werden kann."
				, number:"2"
			},
			q3:
			{
				label: "Wo benutzen Sie Ihr Boot hauptsächlich?"
				, text: "Das Gewässer beeinflusst den Schutz gegen Bewuchs."
				, number:"3"
			},
			q4:
			{
				label: "Wie schnell fährt Ihr Boot?"
				, text: "Die Geschwindigkeit beeinflusst, wie widerstandsfähig das Antifouling sein muss."
				, number:"4"
			},
			q5: 
			{
				label: "Wie oft wird Ihr Boot benutzt?"
				, text: "Weniger genutzte Boote brauchen stärkeren Bewuchsschutz."
				, number:"5"
			},
			q6:
			{
				label: "Welchen Bootstyp haben Sie, und welche Maße hat Ihr Boot?"
				, text: "Messen Sie die Länge und Breite des Bootes entlang der Wasserlinie sowie den Tiefgang (vertikale Distanz von der Wasseroberfläche bis zum tiefsten Punkt)."
				, number:"6"
			},
			q7:
			{
				label: "Gibt es Besonderheiten, die berücksichtigt werden müssen?"
				, text: "Wählen Sie alle Bedingungen aus, die zutreffen. Trifft keine zu, fahren Sie ohne Auswahl fort."
				, number:"7"
			}
		}
		, answers:
		{
			q1a1: 
			{
				label: "Kein Antifouling"
				, text: "Es wurde noch kein Antifouling aufgetragen."
			},
			q1a2: 
			{
				label: "Schlechter Zustand"
				, text: "Risse, Abplatzungen oder lose Stellen im Antifouling."
			},
			q1a3: 
			{
				label: "Unbekannt, aber in gutem Zustand"
				, text: "Ihr jetziges Antifouling ist in einem guten Zustand."
			},
			q1a4: 
			{
				label: "Aktuelles Antifouling in gutem Zustand"
				, text: "Ihr jetziges Antifouling ist in einem guten Zustand. Bitte wählen Sie Ihr aktuelles Antifouling aus."
			},
			q2a1: 
			{
				label: "GFK"
				, text: "Glasfaserkunststoff \/ Fiberglas"
			},
			q2a2: 
			{
				label: "Holz"
				, text: ""
			},
			q2a3: 
			{
				label: "Stahl"
				, text: ""
			},
			q2a4: 
			{
				label: "Aluminium"
				, text: ""
			},
			q3a1: 
			{
				label: "Salzwasser"
				, text: ""
			},
			q3a2: 
			{
				label: "Süßwasser"
				, text: ""
			},
			q3a3: 
			{
				label: "Brackwasser"
				, text: ""
			},
			q4a1: 
			{
				label: "Bis 40 Knoten"
				, text: "Entspricht ~ 74 km\/h"
			},
			q4a2: 
			{
				label: "Bis 70 Knoten"
				, text: "Entspricht ~ 130 km\/h"
			},
			q5a1: 
			{
				label: "Täglich"
				, text: ""
			},
			q5a2: 
			{
				label: "Wöchentlich"
				, text: ""
			},
			q5a3: 
			{
				label: "Monatlich oder seltener"
				, text: ""
			},
			q6a1: 
			{
				label: "Länge an der Wasserlinie"
				, text: "Die Länge des Bootes entlang der Wasserlinie von Bug bis Heck."
			},
			q6a2: 
			{
				label: "Breite an der Wasserlinie"
				, text: "Die breiteste Stelle des Bootes entlang der Wasserlinie von Backbord bis Steuerbord."
			},
			q6a3: 
			{
				label: "Tiefgang"
				, text: "Messen Sie den vertikalen Abstand von der Wasseroberfläche bis zum tiefsten Punkt des Kiels oder Rumpfs."
			},
			q6a4: 
			{
				label: "Bootstyp"
				, text: ""
				, selection:
				{ 
					Motorboot: "Motorboot"
					, Kurzkieler: "Kurzkieler"
					, Langkieler: "Langkieler"
					, Kurzkieler_Katamaran: "Kurzkieler Katamaran"
					, Langkieler_Katamaran: "Langkieler Katamaran"
				}
			},
			q7a1: 
			{
				label: "Boot in Holland"
				, text: ""
			},
			q7a2: 
			{
				label: "Besonders starker Bewuchs im Segelrevier"
				, text: ""
			},
			q7a3: 
			{
				label: "Boot liegt das ganze Jahr im Wasser"
				, text: ""
			},
			q7a4: 
			{
				label: "Tropische Gewässer oder Mittelmeer"
				, text: ""
			},
			q7a5: 
			{
				label: "Trockenfallender, schlammiger Liegeplatz"
				, text: ""
			},
			q7a6: 
			{
				label: "Antifouling muss biozidfrei sein"
				, text: ""
			},
			q7a7: 
			{
				label: "Boot ist ein Trailerboot"
				, text: ""
			},
			q7a8: 
			{
				label: "Selbstpolierendes Antifouling ist im Hafen verboten"
				, text: ""
			},
		}
		, boat:
		{
			label: "Das Boot"
			, name: "Name des Bootes"
			, length: { label: "Länge", info: "Länge der Wasserlinie in Metern" }
			, width: { label: "Breite", info: "Breite des Bootes in Metern" }
			, depth: { label: "Tiefgang", info: "Tiefgang des Bootes in Metern" }
			, material: { label: "Material", info: "" }
			, area: { label: "Unterwasserfläche", info: "Unterwasserfläche in Quadratmetern" }
			, types: 
			{
				Motorboot: "Motorboot"
				, Kurzkieler: "Kurzkieler"
				, Langkieler: "Langkieler"
				, Kurzkieler_Katamaran: "Kurzkieler Katamaran"
				, Langkieler_Katamaran: "Langkieler Katamaran"
			}
		}
		, start:
		{
			label: "Willkommen beim Antifouling-Konfigurator"
			, intro: "Dieser Konfigurator hilft Ihnen bei der Auswahl und Anwendung des passenden Antifoulings für Ihr Boot."
			, text1: "Sie erhalten passende Produktempfehlungen, die Sie auf Wunsch direkt bestellen können."
			, text2: "Außerdem erhalten Sie eine Schritt-für-Schritt-Anleitung für die richtige Verarbeitung an Ihrem Boot."
			, text3: "Dafür beantworten Sie nur sieben einfache Fragen."
			, text4: ""
			, text5: ""
			, begin: "Konfigurator starten"
			, resume: "Letzte Sitzung fortsetzen"
			, extro: "Bei Fragen wenden Sie sich bitte an uns."
		}
		, recipe:
		{
			label: "Anleitung"
			, intro: ""
			, boat:
			{
				label: "(Das Boot)"
			}
			, recommendation: 
			{
				label: "[[product]]"
				,no_product_label: "Keine passende Empfehlung"
			}
			, no_product: 
			{
				label: "Keine passende Empfehlung"
				, text: "Die gewählte Kombination lässt sich mit unserem aktuellen Sortiment nicht zuverlässig abdecken. Bitte kontaktieren Sie uns, damit wir den passenden Beschichtungsaufbau persönlich mit Ihnen prüfen können."
			}
			, product: 
			{
				label: "[[product]]"
				, text: "Für Ihre berechnete Unterwasserfläche von [[area_m]] m² empfehlen wir „[[recommended]]“. Der rechnerische Bedarf liegt bei [[volume_text]] für [[layers_text]]. Die konkrete Warenkorbmenge finden Sie unten, passend zu den verfügbaren Gebinden."
				, unique_selling_points: 
				{
					label: "Das spricht für „[[product]]“:"
					, text: ""
				}
				, colour_selection: 
				{
					label: "Farbauswahl"
					, text: ""
				}
			}
			, alternatives:
			{
				label: "Alternativen"
				, standard: "Standard"
				, premium: "Premium Option"
				, no_biocide: "Biozidfreie Option"
				, no_biocide_premium: "Biozidfreie Premium Option"
			}
			, steps: 
			{
				label: "Schritte"
			}
			, extro: 
			{
				label: ""
				,text: ""
			}
			, order: 
			{
				label: "Mengen und Warenkorb"
				,text: "Für den Warenkorb werden die berechneten Mengen auf verfügbare Gebinde aufgerundet."
				,total: "Gesamt"
				,button: "Antifouling in den Warenkorb" 
                , primer:
                    { text: "Primer [[primer]] in den Warenkorb legen"
                    , button: "[[primer]] in den Warenkorb"
                }
                , both:
                    { text: "Antifouling und Primer in den Warenkorb legen"
                    , button: "Beides in den Warenkorb"
                }
				, button_all: "Alle Produkte in den Warenkorb"
				, progress: "Wird in den Warenkorb gelegt ..."
				, success: "Alle Produkte wurden in den Warenkorb gelegt."
				, failure: "Beim Hinzufügen zum Warenkorb ist ein Fehler aufgetreten."
			}
		}
		, image_urls:
		{
			q1a1:  ["//antifouling.com/cdn/shop/t/11/assets/afc_q1a1_hkt.svg?v=114909192254763235671776106183"]
			,q1a2: ["//antifouling.com/cdn/shop/t/11/assets/afc_q1a2_hkt.svg?v=11300144716628911891776106183"]
			,q1a3: ["//antifouling.com/cdn/shop/t/11/assets/afc_q1a3_hkt.svg?v=47470845012022484801776106183"]
			,q1a4: ["//antifouling.com/cdn/shop/t/11/assets/afc_q1a3_hkt.svg?v=47470845012022484801776106183"]
			,q2a1: ["//antifouling.com/cdn/shop/t/11/assets/afc_q2a1_hkt.svg?v=54333874070524301551776106183"]
			,q2a2: ["//antifouling.com/cdn/shop/t/11/assets/afc_q2a2_hkt.svg?v=14068997010276584331776106183"]
			,q2a3: ["//antifouling.com/cdn/shop/t/11/assets/afc_q2a3_hkt.svg?v=89174801933511874851776106183"]
			,q2a4: ["//antifouling.com/cdn/shop/t/11/assets/afc_q2a4_hkt.svg?v=71962728747906607511776106183"]
			,q3a1: ["//antifouling.com/cdn/shop/t/11/assets/afc_q3a1_hkt.svg?v=116658415130054402811776106183"]
			,q3a2: ["//antifouling.com/cdn/shop/t/11/assets/afc_q3a2_hkt.svg?v=3576946788800499481776106183"]
			,q3a3: ["//antifouling.com/cdn/shop/t/11/assets/afc_q3a3_hkt.svg?v=17880492940940354721776106183"]
			,q4a1: ["//antifouling.com/cdn/shop/t/11/assets/afc_q4a1_hkt.svg?v=101782590197436659421776106183"]
			,q4a2: ["//antifouling.com/cdn/shop/t/11/assets/afc_q4a2_hkt.svg?v=168180222824102609871776106183"]
			,q5a1: ["//antifouling.com/cdn/shop/t/11/assets/afc_q5a1_hkt.svg?v=64496289835535713901776106183"]
			,q5a2: ["//antifouling.com/cdn/shop/t/11/assets/afc_q5a2_hkt.svg?v=101969192190053417861776106183"]
			,q5a3: ["//antifouling.com/cdn/shop/t/11/assets/afc_q5a3_hkt.svg?v=167994270944095586911776106183"]
			,q6a1: ["//antifouling.com/cdn/shop/t/11/assets/afc_q6a1_hkt.svg?v=172398619949456977331776106183"]
			,q6a2: ["//antifouling.com/cdn/shop/t/11/assets/afc_q6a2_hkt.svg?v=70028105502546631291776106183"]
			,q6a3: ["//antifouling.com/cdn/shop/t/11/assets/afc_q6a3_hkt.svg?v=20157173745007113281776106183"]
			,q6a4: ["//antifouling.com/cdn/shop/t/11/assets/afc_q6a4_hkt.svg?v=66020954430246746521776106183"]
			,q7a1: ["//antifouling.com/cdn/shop/t/11/assets/afc_q7a1_hkt.svg?v=46995504077743080831776106183"]
			,q7a2: ["//antifouling.com/cdn/shop/t/11/assets/afc_q7a2_hkt.svg?v=30163970774076845751776106183"]
			,q7a3: ["//antifouling.com/cdn/shop/t/11/assets/afc_q7a3_hkt.svg?v=22275314109055979921776106183"]
			,q7a4: ["//antifouling.com/cdn/shop/t/11/assets/afc_q7a4_hkt.svg?v=108316395860241202751776106183"]
			,q7a5: ["//antifouling.com/cdn/shop/t/11/assets/afc_q7a5_hkt.svg?v=96296367857456445861776106183"]
			,q7a6: ["//antifouling.com/cdn/shop/t/11/assets/afc_q7a6_hkt.svg?v=181676363082020459881776106183"]
			,q7a7: ["//antifouling.com/cdn/shop/t/11/assets/afc_q7a7_hkt.svg?v=26641615343035249981776106183"]
			,q7a8: ["//antifouling.com/cdn/shop/t/11/assets/afc_q7a8_hkt.svg?v=102232174697049649621776106183"]
		}
	}
}

window.xxzpawvbpvwnwawbnazvkkpqvbhwadva = xxzpawvbpvwnwawbnazvkkpqvbhwadva
